import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import UserContext from "../../contexts/UserContext";
import Preloader from "../../components/Preloader";
import NetworkError from "../../components/NetworkError";
import { textes } from "../../constants/textes";
import { config } from "../../constants/config";
import Pagination from "../../components/Pagination";
import Select from "react-select";
import { Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Building, CardText, Cash, Clock, TextParagraph } from "react-bootstrap-icons";
import imageCompression from "browser-image-compression";
import Search from "../Search";
import Abonnement from "./abonnement";
import Option from "./option";

export default function Abonnements() {
    // states
    const { user, logoutUser } = useContext(UserContext);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [compressing, setCompressin] = useState(false);
    const [error, setError] = useState(false);
    const [addstate, setAddstate] = useState(false);

    const [fetching, setFetching] = useState(false);

    const [elementsList, setElementsList] = useState([]);
    const [nbpage, setNbpage] = useState(1);
    const [nbelement, setNbelement] = useState(0);
    const [page, setPage] = useState(0);

    const [isSearch, setIsSearch] = useState(false);
    const [chaine, setChaine] = useState('');

    const [lib, setlib] = useState("");
    const [profile, setprofile] = useState("");
    const [desc, setdesc] = useState("");
    const [duree, setduree] = useState("");
    const [prix, setprix] = useState("");
    const [typeabonnement, settypeabonnement] = useState('');
    const [typeabonnementsList, settypeabonnementsList] = useState([]);
    const [options, setoptions] = useState([]);
    const [option, setoption] = useState('');
    const [nbsite, setnbsite] = useState('');
    const [picture, setPicture] = useState('');
    const [pictureprev, setPictureprev] = useState('/assets/imgs/no-image.png');

    const [unite, setUnite] = useState("");

    const unites = [
        {
            label: "Année (s)",
            value: "years",
        },
        {
            label: "Mois",
            value: "months",
        },
        {
            label: "Jour (s)",
            value: "days",
        },
    ];

    const showErrorMessage = (msg) => {
        toast.error(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    };


    const showSuccesMessage = (msg) => {
        toast.success(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    };

    const getElementsList = async (p) => {
        setLoading(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.app.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/subscriptions?limit=${config.app.limit}&page=${p + 1}&etat=1,2,3,4,5,6,7,8,9`, requestOptions).then((response) => {

            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data?.body?.data);
                    if (data?.head) {
                        let clientarray = [];

                        clientarray = data?.body?.data;
                        setElementsList(clientarray);
                        setNbpage(data?.body?.pages);
                        setNbelement(data?.body?.length);
                        setLoading(false);
                    } else {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            setError(true);
                            setLoading(false);
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                setError(true);
                setLoading(false);
            }

        }).catch((err) => {
            // console.log("error", err);
            setError(true);
            setLoading(false);
        });
    }

    const autoSearchElement = async (c) => {
        setPage(0);
        if ((c && !isSearch) || (c && isSearch)) {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
            myHeaders.append("token", config.app.PUBLICKEY);
            myHeaders.append("apikey", user.token);
            myHeaders.append("cpte", user.code);
            myHeaders.append("prof", user.profil);
            myHeaders.append("conn", user.espace);


            var requestOptions = {
                method: 'GET',
                headers: myHeaders,
                // body: urlencoded,
                redirect: 'follow'
            };

            // console.log("data send", urlencoded)

            await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/subscriptions?crit=${c}&etat=1,2,3,4,5,6,7,8,9`, requestOptions).then((response) => {

                if (response?.status === 200) {
                    response.json().then(async (data) => {
                        if (data?.head) {
                            // console.log("resonse jsondecode", data);
                            let clientarray = [];
                            clientarray = data?.body?.data;
                            setElementsList(clientarray);
                            setNbpage(data?.body?.pages);
                            setNbelement(data?.body?.length);
                            // setLoading(false);
                        } else {
                            if (data?.body?.data?.msg === "expiredsession") {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                setError(true);
                            }
                            // setLoading(false);
                        }
                    });
                } else if (response?.status === 401) {
                    logoutUser();
                    navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                } else {
                    setError(true);
                    // setLoading(false);
                }

            }).catch((err) => {
                // console.log("error", err);
                setError(true);
                // setLoading(false);
            });
        } else if (c !== "" && isSearch) {
            setIsSearch(false);
            getElementsList(page);
        } else {
            setIsSearch(false);
            getElementsList(page);
        }
    }

    const getTypeabonnementsList = async () => {

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.domain.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.domain.BASE_URL}/${config.domain.PROJECT}/nouns?nomtab=tabonnement&page=1&limit=100000`, requestOptions).then((response) => {

            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data);
                    if (data?.head) {
                        let clientarray = [];

                        clientarray = data?.body?.data;

                        let clientarraydata = [];
                        await clientarray.forEach(element => {
                            clientarraydata.push({ label: element.lib, value: element.code });
                        });

                        settypeabonnementsList(clientarraydata);
                    } else {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            // console.log("get departement list", "error")
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                // console.log("get staut erreur", "error");
            }

        }).catch((err) => {
            console.log("error get tabonnement list", err);
            // setError(true);
            // setLoading(false);
        });
    }

    const handlepicturechange = (e) => {
        const file = e.target.files[0];
        setPicture(file)
        TransformPicture(file);
        // console.log("recto prev", rectoprev)
    };

    const TransformPicture = async (file) => {
        const reader = new FileReader();

        const options = {
            maxSizeMB: config.app.maxsizefileoption,
            maxWidthOrHeight: 500,
            useWebWorker: true
        };

        if (file) {
            if (file.size > config.app.maxsizefile * 1024) {
                setCompressin(true);
                await imageCompression(file, options).then((img) => {
                    reader.readAsDataURL(img);
                    reader.onloadend = () => {
                        setPictureprev(reader.result);
                    };
                });
                setCompressin(false);
            } else {
                reader.readAsDataURL(file);
                reader.onloadend = () => {
                    setPictureprev(reader.result);
                };
            }

        } else {
            setPictureprev("/assets/imgs/no-image.png");
        }
    };

    const handleAddOption = () => {
        const list = [...options];
        list.push({ label: option });
        setoptions(list);
        setoption('');
    }

    const handleDeleteOption = async (index) => {
        const list = [...options];
        list.splice(index, 1);
        setoptions(list);
    }


    // comportements
    useEffect(() => {
        getElementsList(page);
        getTypeabonnementsList();
    }, []);

    useEffect(() => {
        const stimeout = setTimeout(() => {
            autoSearchElement(chaine);
        }, 1000);

        return () => clearTimeout(stimeout);
    }, [chaine]);


    const handleSubmit = async (e) => {
        e.preventDefault();

        setFetching(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.app.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var urlencoded = new URLSearchParams();
        if (lib) urlencoded.append("lib", lib);
        if (profile) urlencoded.append("prof", profile);
        if (desc) urlencoded.append("descr", desc);
        if (duree && unite) urlencoded.append("duree", duree + " " + unite["value"]);
        if (prix) urlencoded.append("prix", prix);
        if (typeabonnement) urlencoded.append("codetabonnement", typeabonnement["value"]);
        if (options.length > 0) urlencoded.append("options", options.map((i) => i["label"]));
        if (nbsite) urlencoded.append("nbsite", nbsite);
        if (picture) urlencoded.append("img", pictureprev);
        urlencoded.append("defaut", false);
        urlencoded.append("edit", true);
        urlencoded.append("etatdef", "En service");

        var requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: urlencoded,
            redirect: "follow",
        };

        // console.log("data send", urlencoded)

        await fetch(
            `${config.app.BASE_URL}/${config.app.PROJECT}/subscriptions`,
            requestOptions
        ).then((response) => {
            if (response?.status === 200 || response?.status === 201) {
                response.json().then(async (data) => {
                    // console.log("resonse ajout droit", data);
                    if (!data?.head) {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            setFetching(false);
                            showErrorMessage(data?.body?.data?.msg);
                        }
                    } else {
                        showSuccesMessage(textes.fr.abonnementaddedlabel);
                        setAddstate(false);
                        getElementsList(page);
                        setlib("");
                        setprofile("");
                        setdesc("");
                        setduree("");
                        setprix("");
                        settypeabonnement("");
                        setPicture("");
                        setPictureprev('/assets/imgs/no-image.png');
                        setUnite("");
                        setFetching(false);
                    }

                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                // console.log("resonse ", response);
                // setError(true);
                showErrorMessage(textes.fr.serviceunavaillable);
                setFetching(false);
            }
        }).catch((err) => {
            // console.log("error", err);
            // setError(true);
            showErrorMessage(textes.fr.serviceunavaillable);
            setFetching(false);
        });
    };


    // affichages
    return (
        <div className="row">
            <div className="col-md-12">
                {loading && <Preloader />}
                {!loading && error && <NetworkError />}
                {!loading && !error && (
                    <div
                        className="col-md-12"
                        style={{
                            paddingTop: 8,
                            borderTop: "1px solid #ddd",
                            borderRadius: 8,
                        }}
                    >
                        <div className="row">
                            <div className="col-md-12 mb-3">
                                <Search
                                    chaine={chaine}
                                    setChaine={setChaine}
                                    // search={searchEmployee}
                                    placeholder="Rechercher..."
                                />
                            </div>
                            <div className="col-md-12 mb-3">
                                <div className="card shadow mb-4">
                                    <div className="card-header py-3">
                                        {!addstate && (
                                            <button
                                                data-toggle="tooltip"
                                                title={textes.fr.newabonnementlabel}
                                                onClick={() => setAddstate(true)}
                                                data-placement="left"
                                                className="btn-shadow ml-3 btn btn-primary btn-sm float-right"
                                            >
                                                <i className="fa fa-plus mr-1"></i>{" "}
                                                <span>{textes.fr.newabonnementlabel}</span>
                                            </button>
                                        )}
                                        <h6 className="m-0 ">
                                            {addstate
                                                ? textes.fr.abonnementinfoslabel
                                                : textes.fr.listabonnementlabel}
                                        </h6>
                                    </div>
                                    {!addstate && (
                                        <div className="card-body">
                                            <div className="table-responsive mb-3">
                                                <table className="mb-0 table table-bordered">
                                                    <thead className="bg-primary">
                                                        <tr className="bg-primary text-white">
                                                            <th className="text-center">#</th>
                                                            <th>Abonnement</th>
                                                            <th>Durée</th>
                                                            <th>Prix</th>
                                                            <th>{textes.fr.statelabel}</th>
                                                            <th>{textes.fr.addeddatelabel}</th>
                                                            <th className="text-center">
                                                                {textes.fr.actionlabel}
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {elementsList.length === 0 && (
                                                            <tr style={{ borderStyle: "none" }}>
                                                                <th colSpan={7} className="text-center">
                                                                    {textes.fr.noabonnementfound}
                                                                </th>
                                                            </tr>
                                                        )}
                                                        {elementsList.length > 0 &&
                                                            elementsList?.map((item, index) => (
                                                                <Abonnement
                                                                    abonnement={item}
                                                                    position={config.app.limit * page + index}
                                                                    key={index}
                                                                />
                                                            ))}
                                                        {/* {elementsList.length > 0 &&
                                                            elementsList?.map((item, index) => (
                                                                <Abonnement
                                                                    abonnement={item}
                                                                    position={config.app.limit * page + index}
                                                                    key={index}
                                                                />
                                                            ))} */}
                                                    </tbody>
                                                </table>
                                            </div>
                                            <Pagination
                                                nbpage={nbpage}
                                                getList={getElementsList}
                                                page={page}
                                                setPage={setPage}
                                            />
                                        </div>
                                    )}
                                    {addstate && (
                                        <div className="card-body">
                                            <form style={{ width: "100%" }} onSubmit={handleSubmit}>
                                                <div className="row">
                                                    <div className="col-md-12 mb-3">
                                                        <div className="row">
                                                            <div className="col-md-4 mb-3">
                                                                <div className="row">
                                                                    <div className="col-md-12 mb-2">
                                                                        <label htmlFor="logo" className="form-label">Image illustrative</label>
                                                                        <input className="form-control" type="file" id="logo" onChange={handlepicturechange} />
                                                                    </div>
                                                                    {compressing && <div className="col-md-12 p-5 mb-3">
                                                                        <Spinner
                                                                            as="span"
                                                                            animation="border"
                                                                            size="lg"
                                                                            role="status"
                                                                            aria-hidden="true"
                                                                            style={{ display: "block", marginLeft: 'auto', marginRight: 'auto' }}
                                                                        />
                                                                    </div>}
                                                                    {!compressing && <div className="col-md-12 mb-3">
                                                                        <img alt="" src={pictureprev} className={`rounded `} style={{ width: "100%", border: "1px solid" }} />
                                                                    </div>}
                                                                    <div className="col-md-12 mb-3">
                                                                        <h6 className="mb-2">Ajouter des options</h6>
                                                                        <div className="row">
                                                                            <div className="col-md-12 mb-1">
                                                                                <label htmlFor="option" className="mb-1">Option</label>
                                                                                <div className="input-group flex-nowrap">
                                                                                    <span className="input-group-text" id="option"><TextParagraph /></span>
                                                                                    <input
                                                                                        type="text"
                                                                                        className="form-control"
                                                                                        placeholder={textes.fr.entervaluelabel}
                                                                                        value={option}
                                                                                        onChange={(e) =>
                                                                                            setoption(e.target.value)
                                                                                        }
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-md-12 mb-3">
                                                                                <button
                                                                                    title={textes.fr.validateaddlabel}
                                                                                    className="btn-shadow w-auto btn btn-primary btn-sm float-right"
                                                                                    disabled={option ? false : true}
                                                                                    onClick={handleAddOption}
                                                                                >
                                                                                    <i className="fa fa-plus mr-3"></i> Ajouter
                                                                                </button>
                                                                            </div>
                                                                            <div className="col-md-12 mb-3">
                                                                                <h6 className="mb-2">Liste des options de l'abonnement</h6>
                                                                                <div className="table-responsive mb-3">
                                                                                    <table className="mb-0 table table-bordered">
                                                                                        <thead className="bg-primary">
                                                                                            <tr className="bg-primary text-white">
                                                                                                <th className="text-center">#</th>
                                                                                                <th>Option</th>
                                                                                                <th className="text-center">{textes.fr.actionlabel}</th>
                                                                                            </tr>
                                                                                        </thead>
                                                                                        <tbody>
                                                                                            {(options.length === 0) && <tr style={{ borderStyle: "none" }}>
                                                                                                <th colSpan={3} className="text-center">Aucune option trouvée</th>
                                                                                            </tr>}
                                                                                            {
                                                                                                (options.length > 0) && options?.map((item, index) => (
                                                                                                    <Option opt={item} position={index} key={index} handledelete={() => handleDeleteOption(index)} />
                                                                                                ))
                                                                                            }
                                                                                        </tbody>
                                                                                    </table>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-8 mb-3">
                                                                <div className="row">
                                                                    <div className="col-md-12 mb-3">
                                                                        <label htmlFor="typeabonnement" className="mb-1">
                                                                            {textes.fr.typeabonnementlabel}
                                                                        </label>
                                                                        <Select
                                                                            id="typeabonnement"
                                                                            name="typeabonnement"
                                                                            placeholder={textes.fr.selectlabel}
                                                                            options={typeabonnementsList}
                                                                            value={typeabonnement}
                                                                            onChange={(selected) => {
                                                                                settypeabonnement(selected);
                                                                            }}
                                                                            isClearable
                                                                        />
                                                                    </div>
                                                                    <div className="col-md-6 mb-3">
                                                                        <label htmlFor="lib" className="mb-1">
                                                                            Libelle
                                                                        </label>
                                                                        <div className="input-group flex-nowrap">
                                                                            <span
                                                                                className="input-group-text"
                                                                                id="lib"
                                                                            >
                                                                                <TextParagraph />
                                                                            </span>
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                placeholder={textes.fr.entervaluelabel}
                                                                                value={lib}
                                                                                onChange={(e) =>
                                                                                    setlib(e.target.value)
                                                                                }
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-6 mb-3">
                                                                        <label htmlFor="profile" className="mb-1">
                                                                            Profile
                                                                        </label>
                                                                        <div className="input-group flex-nowrap">
                                                                            <span
                                                                                className="input-group-text"
                                                                                id="profile"
                                                                            >
                                                                                <CardText />
                                                                            </span>
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                placeholder={textes.fr.entervaluelabel}
                                                                                value={profile}
                                                                                onChange={(e) =>
                                                                                    setprofile(e.target.value)
                                                                                }
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-4 mb-3">
                                                                        <label htmlFor="prix" className="mb-1">
                                                                            Prix
                                                                        </label>
                                                                        <div className="input-group flex-nowrap">
                                                                            <span
                                                                                className="input-group-text"
                                                                                id="prix"
                                                                            >
                                                                                <Cash />
                                                                            </span>
                                                                            <input
                                                                                type="number"
                                                                                min={0}
                                                                                className="form-control"
                                                                                placeholder={textes.fr.entervaluelabel}
                                                                                value={prix}
                                                                                onChange={(e) => { setprix(e.target.value) }}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-4 mb-3">
                                                                        <label htmlFor="duree" className="mb-1">
                                                                            {textes.fr.durelabel}
                                                                        </label>
                                                                        <div className="input-group flex-nowrap">
                                                                            <span
                                                                                className="input-group-text"
                                                                                id="duree"
                                                                            >
                                                                                <Clock />
                                                                            </span>
                                                                            <input
                                                                                type="number"
                                                                                className="form-control"
                                                                                placeholder="Entrez la durée"
                                                                                value={duree}
                                                                                onChange={(e) =>
                                                                                    setduree(e.target.value)
                                                                                }
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-4 mb-3">
                                                                        <label htmlFor="unite" className="mb-1">
                                                                            Unité
                                                                        </label>
                                                                        <Select
                                                                            id="unite"
                                                                            name="unite"
                                                                            placeholder="Sélectionner l'unité"
                                                                            options={unites}
                                                                            value={unite}
                                                                            onChange={(selected) => {
                                                                                setUnite(selected);
                                                                            }}
                                                                        />
                                                                    </div>
                                                                    <div className="col-md-12 mb-3">
                                                                        <label htmlFor="nbsite" className="mb-1">Nombre de site</label>
                                                                        <div className="input-group flex-nowrap">
                                                                            <span className="input-group-text" id="nbsite"><Building /></span>
                                                                            <input
                                                                                type="number"
                                                                                min={0}
                                                                                className="form-control"
                                                                                placeholder="Entrez le nombre de site"
                                                                                value={nbsite}
                                                                                onChange={(e) =>
                                                                                    setnbsite(e.target.value)
                                                                                }
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-12 mb-3">
                                                                        <label htmlFor="desc" className="mb-1">
                                                                            Description
                                                                        </label>
                                                                        <div className="input-group flex-nowrap">
                                                                            <span
                                                                                className="input-group-text"
                                                                                id="desc"
                                                                            >
                                                                                <TextParagraph />
                                                                            </span>
                                                                            <textarea
                                                                                className="form-control"
                                                                                placeholder={
                                                                                    textes.fr.descriptionlabel
                                                                                }
                                                                                value={desc}
                                                                                style={{ height: 154 }}
                                                                                onChange={(e) =>
                                                                                    setdesc(e.target.value)
                                                                                }
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 mt-2">
                                                        <button
                                                            type="submit"
                                                            title={textes.fr.newabonnementlabel}
                                                            className="btn-shadow ml-3 btn btn-primary btn-sm float-right"
                                                            disabled={
                                                                typeabonnement["value"] && lib && profile && duree && unite["value"] && prix
                                                                    ? false
                                                                    : true
                                                            }
                                                        >
                                                            <i className="fa fa-check mr-2"></i>
                                                            <span>Valider</span>{" "}
                                                            {fetching && (
                                                                <Spinner
                                                                    as="span"
                                                                    animation="border"
                                                                    size="sm"
                                                                    role="status"
                                                                    aria-hidden="true"
                                                                />
                                                            )}
                                                        </button>
                                                        <button
                                                            onClick={() => {
                                                                setAddstate(false);
                                                                getElementsList(page);
                                                                setlib("");
                                                                setprofile("");
                                                                setdesc("");
                                                                setduree("");
                                                                setprix("");
                                                                settypeabonnement("");
                                                                setPicture("");
                                                                setPictureprev('/assets/imgs/no-image.png');
                                                                setUnite("");
                                                                setnbsite("");
                                                                setoption("");
                                                                setoptions([]);
                                                            }}
                                                            title={textes.fr.cancel}
                                                            className="btn-shadow ml-3 btn btn-danger btn-sm float-right"
                                                        >
                                                            <i className="fa fa-reply mr-1"></i>{" "}
                                                            <span>{textes.fr.cancel}</span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
